import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
  getGroups: function(params, search) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/groups" + params + search);
  },
  getGroupsWithBasicDetail: function(params, search) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/groups-basic-detail" + params + search);
  },
  getGroup: function(groupId, params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/groups/" + groupId + params);
  },
  getGroupUsers: function(groupId, params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/groups/users/" + groupId + params);
  },
  getGroupUsersWithState: function(groupId, params) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/group/users/all/" + groupId + params
    );
  },
  createGroup: function(group) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/groups", {
      name: group.name,
      description: group.description
    });
  },
  updateGroup: function(id, group) {
    return axios.patch(IMPROVE_CONFIG.API_URL + "/groups/" + id, {
      name: group.name,
      description: group.description
    });
  },
  deleteGroup: function(groupId) {
    return axios.delete(IMPROVE_CONFIG.API_URL + "/groups/" + groupId);
  },
  assignUsers: function(groupId, members, unassignedMembers) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/groups/users/add/" + groupId, {
      assign_users: members,
      unassign_users: unassignedMembers
    });
  },
  getGroupEnrolledUsers: function(groupId, params, search) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/group/enrolled-users/" + groupId + params + search
    );
  },
  getGroupUnenrolledUsers: function(groupId, params, search) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/group/unenrolled-users/" + groupId + params + search
    );
  },
  getUnAssignedGroups: function(groupIds, params, search) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/groups/unassigned" + groupIds + params + search);
  },
  exportGroupReport: function (id){
      return axios.get(IMPROVE_CONFIG.API_URL + "/group-report?id=" + id);
  }
};
